var map = {
	"./da.json": 896,
	"./de.json": 897,
	"./en.json": 898,
	"./es.json": 899,
	"./fr.json": 900,
	"./pl.json": 901,
	"./pt.json": 902,
	"./ru.json": 903,
	"./sv.json": 904,
	"./uk.json": 905,
	"./zh_CN.json": 906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 895;